import { useContext, useEffect } from 'react';
import { generatePath, useParams, useRouteMatch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
  ActionButton,
  Panel,
  PanelBody,
  PanelHeader,
  PanelSubtitle,
  PanelTitle,
  PanelTitleButton,
  PanelTitleButtonsGroup,
  PanelTitleWrapper
} from 'components/panel';
import messages from 'messages';
import Breadcrumbs from 'components/breadcrumbs/Breadcrumbs';
import Breadcrumb from 'components/breadcrumbs/Breadcrumb';
import {
  ROUTE_PERSONS_ENTITY_PERSON,
  ROUTE_PERSONS_ENTITY_PERSON_GLOBAL_EDIT,
  ROUTE_PERSONS_ENTITY_PERSON_GLOBAL,
  ROUTE_PERSONS_ENTITY,
  ROUTE_PERSONS_ENTITY_PERSON_MEDICAL,
  ROUTE_PERSONS_ENTITY_PERSON_VIDEOS,
  ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS,
  ROUTE_PERSONS_ENTITY_PERSON_GROUPS,
  ROUTE_PERSONS_ENTITY_PERSON_DOCS,
  ROUTE_PERSONS_ENTITY_PERSON_EDIT,
  ROUTE_PERSONS_ENTITY_PERSON_TESTS,
  ROUTE_PERSONS_ENTITY_PERSON_INPUT_DATA
} from 'routes/RouteList';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import { StoreContext } from 'index';
import { getDateInYears } from 'utils/date';
import usePerson from 'hooks/queries/usePerson';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import ContextMenuWrapper from 'components/menu/ContextMenuWrapper';
import ContextMenu from 'components/menu/ContextMenu';
import PersonTabs from 'containers/pages/persons/PersonTabs';
import Loader from 'components/loader/Loader';

const Person = () => {
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const { entityId, groupId, personId } = useParams();
  const { fetchPerson, error, loading } = usePerson({ personId: personId });
  const person = useEntityContext(s => s.person);

  const active = useRouteMatch([
    ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS,
    ROUTE_PERSONS_ENTITY_PERSON_MEDICAL,
    ROUTE_PERSONS_ENTITY_PERSON_TESTS,
    ROUTE_PERSONS_ENTITY_PERSON_GROUPS,
    ROUTE_PERSONS_ENTITY_PERSON_DOCS,
    ROUTE_PERSONS_ENTITY_PERSON_VIDEOS,
    // ROUTE_PERSONS_ENTITY_PERSON_TRAININGS,
    ROUTE_PERSONS_ENTITY_PERSON_GLOBAL_EDIT,
    ROUTE_PERSONS_ENTITY_PERSON_GLOBAL,
    ROUTE_PERSONS_ENTITY_PERSON_EDIT,
    ROUTE_PERSONS_ENTITY_PERSON,
    ROUTE_PERSONS_ENTITY_PERSON_INPUT_DATA
  ]);

  useEffect(() => {
    const fetchPersonData = async () => {
      await fetchPerson(personId);
    };
    if (person?.id !== personId) {
      fetchPersonData();
    }
  }, [entityId, personId]);

  return (
    <>
      <Panel active={active.isExact}>
        {error && <RetryPanel />}
        {loading && !person && <Loader />}
        {person && (
          <>
            <PanelHeader>
              <Breadcrumbs>
                <Breadcrumb
                  to={generatePath(ROUTE_PERSONS_ENTITY, {
                    entityId,
                    groupId
                  })}
                >
                  <FormattedMessage {...messages.breadcrumbSporters} />
                </Breadcrumb>
              </Breadcrumbs>
              <PanelTitleWrapper>
                <PanelTitle>
                  {person.firstname} {person.lastname}
                </PanelTitle>
                {!user.isVitaleOrg && (
                  <PanelSubtitle>
                    {person.birthdate && (
                      <FormattedMessage
                        {...messages.labelSporterAge}
                        values={{ age: getDateInYears(person.birthdate) }}
                      />
                    )}
                  </PanelSubtitle>
                )}
              </PanelTitleWrapper>
              <PanelTitleButtonsGroup>
                <ActionButton />
                <ContextMenuWrapper trigger={<PanelTitleButton />}>
                  <ContextMenu />
                </ContextMenuWrapper>
              </PanelTitleButtonsGroup>
            </PanelHeader>

            <PanelBody>
              <PersonTabs />
            </PanelBody>
          </>
        )}
      </Panel>
    </>
  );
};

export default Person;
